export default __webpack_public_path__ + "static/media/toeic.32e23465.jpg";